<template>
  <do-handle></do-handle>
</template>

<script>
export default {
  components: {
    doHandle: resolve => {require(['@/views/dataManage/index.vue'], resolve);},
  },
  data(){
    return{

    }
  },
  methods:{

  },
  mounted() {
  }
}
</script>
